// Generated by web/scripts/generate-owner-rule-stores.mjs from web/src/privacy/storeRegister.ts. Do not edit.
import type { StoreAreaType } from '@/privacy/storeRegister';

/** The person entries the owner rule drops when a different person signs in (PPD-2): key and areas only. */
export const OWNER_RULE_STORES: readonly { key: string; areas: readonly StoreAreaType[] }[] = [
  {
    key: 'featit:accents',
    areas: ['local'],
  },
  {
    key: 'featit:accents:unsaved',
    areas: ['local'],
  },
  {
    key: 'featit:locale',
    areas: ['local'],
  },
  {
    key: 'featit:format-region',
    areas: ['local'],
  },
  {
    key: 'featit:signOutRequired',
    areas: ['local'],
  },
  {
    key: 'featit:connector-connected',
    areas: ['session'],
  },
  {
    key: 'featit:waiting:study',
    areas: ['local'],
  },
  {
    key: 'featit:commitDiffLayout',
    areas: ['local'],
  },
  {
    key: 'featit:commitFilesView',
    areas: ['local'],
  },
  {
    key: 'featit.reviewLooked.*',
    areas: ['local'],
  },
  {
    key: 'featit:artefact-view-scripts',
    areas: ['local'],
  },
  {
    key: 'featit.decisionDraft.*',
    areas: ['session'],
  },
  {
    key: 'featit.fileTabs.v1.*',
    areas: ['session'],
  },
  {
    key: 'featit.newItemRun.*',
    areas: ['session'],
  },
  {
    key: 'featit.newItemDraft.*',
    areas: ['session'],
  },
  {
    key: 'featit.guestAnswers.*',
    areas: ['session'],
  },
  {
    key: 'featit-new-item-files',
    areas: ['indexeddb'],
  },
  {
    key: 'featit:local-sync:*',
    areas: ['local'],
  },
  {
    key: 'featit:local-sync@*',
    areas: ['local'],
  },
  {
    key: 'featit-local-sync:*',
    areas: ['indexeddb'],
  },
  {
    key: 'featit-local-sync',
    areas: ['indexeddb'],
  },
  {
    key: 'featit.machine-history.v1',
    areas: ['local'],
  },
  {
    key: 'featit:feedbacks',
    areas: ['local'],
  },
  {
    key: 'featit:terminalSizeMode',
    areas: ['local'],
  },
  {
    key: 'featit:agentsBoardMaxWatches',
    areas: ['local'],
  },
  {
    key: 'featit:agentsBoardTileSize',
    areas: ['local'],
  },
  {
    key: 'featit:boardWatchOrder',
    areas: ['local'],
  },
  {
    key: 'featit:terminalInputOptIn',
    areas: ['local'],
  },
  {
    key: 'featit.externalAccountLinkReturn',
    areas: ['session'],
  },
  {
    key: 'featit:pushRegisteredAtLaunch',
    areas: ['local'],
  },
  {
    key: 'featit:placeOwner',
    areas: ['local'],
  },
  {
    key: 'featit:appScope',
    areas: ['local'],
  },
  {
    key: 'featit:selectedProjectId',
    areas: ['local', 'session'],
  },
  {
    key: 'featit:selectedWorkAreaName',
    areas: ['local', 'session'],
  },
  {
    key: 'featit:selectedWorkAreaRefs',
    areas: ['local', 'session'],
  },
  {
    key: 'featit:selectedWorkAreaHadMark',
    areas: ['local', 'session'],
  },
  {
    key: 'featit:workAreaScope',
    areas: ['local', 'session'],
  },
  {
    key: 'featit:lastOpenedWorkAreaId',
    areas: ['local'],
  },
  {
    key: 'featit:recentWorkAreaIds',
    areas: ['local'],
  },
  {
    key: 'featit:scroll-position:*',
    areas: ['session'],
  },
  {
    key: 'featit:row-heights',
    areas: ['session'],
  },
  {
    key: 'featit:link-open:*',
    areas: ['session'],
  },
  {
    key: 'featit:history-from:*',
    areas: ['session'],
  },
  {
    key: 'featit:history-from-key:*',
    areas: ['session'],
  },
  {
    key: 'featit:phoneDrillSplitPlace:*',
    areas: ['session'],
  },
  {
    key: 'featit:passkeyOffer',
    areas: ['session'],
  },
  {
    key: 'featit:viewChoices:v1:*',
    areas: ['local'],
  },
  {
    key: 'featit:homeRoadmapRange:*',
    areas: ['local'],
  },
  {
    key: 'featit:roadmapPreferences:*',
    areas: ['local'],
  },
  {
    key: 'featit:activityStatusColumns:*',
    areas: ['local'],
  },
  {
    key: 'featit:phoneActivitySelection:*',
    areas: ['session'],
  },
  {
    key: 'featit:schedules:lastWhere:*',
    areas: ['local'],
  },
  {
    key: 'featit:pageTreeExpanded:*',
    areas: ['local'],
  },
  {
    key: 'featit:viewFolderExpanded:*',
    areas: ['local'],
  },
  {
    key: 'featit:viewListExpanded:*',
    areas: ['local'],
  },
  {
    key: 'featit:pagesGroupExpanded:*',
    areas: ['local'],
  },
  {
    key: 'featit:allWorkAreasViewsExpanded',
    areas: ['local'],
  },
  {
    key: 'featit:viewsOverviewFoldedWorkAreas',
    areas: ['local'],
  },
  {
    key: 'featit:viewsOverviewTileCounts',
    areas: ['local'],
  },
  {
    key: 'featit:allWorkAreasViewsOpenWorkAreas',
    areas: ['local'],
  },
  {
    key: 'featit:viewReaderState:*',
    areas: ['session'],
  },
  {
    key: 'featit:workAreaBoxHeight:*',
    areas: ['local'],
  },
  {
    key: 'featit:workItemsColumns',
    areas: ['session'],
  },
  {
    key: 'featit:workItemsColumns:*',
    areas: ['session'],
  },
  {
    key: 'featit:workItemsSortMode:*',
    areas: ['session'],
  },
  {
    key: 'featit:workItemsCollapsedGroups',
    areas: ['session'],
  },
  {
    key: 'featit:workItemsDisplayMode',
    areas: ['session'],
  },
  {
    key: 'featit:workItemsSortMode',
    areas: ['session'],
  },
  {
    key: 'featit:workItemsDetailWidth',
    areas: ['session'],
  },
  {
    key: 'featit:itemPropertiesExpanded',
    areas: ['local'],
  },
  {
    key: 'featit:itemPhonePropertiesExpanded',
    areas: ['local'],
  },
  {
    key: 'featit:projectSelectorExpanded',
    areas: ['session'],
  },
  {
    key: 'featit:activityDetailPanelHeight',
    areas: ['local'],
  },
  {
    key: 'featit:agentUsageChartSeries',
    areas: ['local'],
  },
  {
    key: 'featit:currentLayout',
    areas: ['local'],
  },
  {
    key: 'featit:badgeCounts',
    areas: ['local'],
  },
  {
    key: 'featit:switcherOrder',
    areas: ['local'],
  },
];
